<template>
  <div
    class="primary--text text-h5 font-weight-bold font-italic text-uppercase"
    :class="{ 'text-md-h4': !small }"
  >
    <span
      class="d-inline-block position-relative font-secondary title-widget"
      :class="{ 'title-widget-small': small }"
    >
      <img
        class="d-block title-widget-icon"
        src="../../assets/img/vinheta.png"
      />
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.title-widget {
  &-icon {
    height: 94px;
    left: -42px;
    pointer-events: none;
    position: absolute;
    top: -26px;

    @media screen and (max-width: 960px) {
      height: 60px;
      left: -28px;
      top: -14px;
    }
  }

  &.title-widget-small {
    .title-widget-icon {
      height: 60px;
      left: -28px;
      top: -14px;
    }
  }
}
</style>
